import React from "react";
import "./Privacy_Policy.css";
import Accept_Btn from "../common_components/common_btn/accept_btn/Accept_Btn";
import Decline_Btn from "../common_components/common_btn/decline_btn/Decline_Btn";
import Common_Banner from "../common_components/common_banner/Common_Banner";
import Book_Vehicle from "../common_components/book_vehicle/Book_Vehicle";

const Privacy_Policy = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Privacy Policy", link: "", isActive: true },
  ];

  return (
    <>
      <section className="Privacy_Policy">
        <Common_Banner
          imgSrc="/assets/images/common_banners/privacy_policy.png"
          title_text="Privacy Policy"
          breadcrumbs={breadcrumbs}
        />

        <div className="container">
          <div className="card card_div">
            {/* <p className="intro">
                UrbanBuild is committed to protecting your privacy. This Privacy
                Policy explains how we collect, use, share, and safeguard your
                personal information when you use our mobile application.
              </p> */}

            <h2 className="head_div">1. Information Collection</h2>
            <div className="description_div">
              <p className="grey_class">
                We collect the following information to provide and improve our
                services:
              </p>

              <p className="grey_class">
                <ul>
                  <li>
                    Personal Information: Name, phone number, email address,
                    location data.
                  </li>
                  <li>
                    Payment Information: Credit/debit card details or digital
                    wallet information.
                  </li>
                  <li>
                    Usage Data: Ride history, preferences, and interactions with
                    the App.
                  </li>
                  <li>Our Website :- gravitydrive.in</li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">2. Use of Information</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>To facilitate ride bookings and process payments.</li>
                  <li>
                    To personalize user experience and improve service quality.
                  </li>
                  <li>
                    To comply with legal obligations and resolve disputes.
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">3. Data Sharing</h2>
            <div className="description_div">
              <p className="grey_class">We may share your information with:</p>
              <p className="grey_class">
                <ul>
                  <li>Drivers for ride coordination;</li>
                  <li>
                    Third-party service providers (e.g., payment processors);
                  </li>
                  <li>Law enforcement agencies when required by law.</li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">4. Data Security</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    We implement industry-standard security measures to protect
                    your data.
                  </li>
                  <li>
                    However, no method of transmission over the internet is
                    completely secure, and we cannot guarantee absolute
                    security.
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">5. User Rights</h2>
            <div className="description_div">
              <p className="grey_class">You have the right to:</p>
              <p className="grey_class">
                <ul>
                  <li>Access, correct, or delete your personal information;</li>
                  <li>
                    Withdraw consent for data processing (subject to applicable
                    laws).
                  </li>
                </ul>
              </p>
              <p className="grey_class">
                To exercise these rights, contact us at info@gravitydrive.in.
              </p>
            </div>

            <h2 className="head_div">6. Google Play Store Compliance</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    1. Content Guidelines
                    <ul>
                      <li>
                        The App complies with Google Play Store's content
                        policies, including restrictions on violence, hate
                        speech, and adult content.
                      </li>
                      <li>
                        The App does not promote gambling, alcohol, or tobacco
                        products.
                      </li>
                      <li>
                        In-app purchases and subscriptions are clearly
                        disclosed.
                      </li>
                    </ul>
                  </li>

                  <li>
                    2. Advertising and Monetization
                    <ul>
                      <li>
                        The App does not display intrusive ads or engage in
                        deceptive practices.
                      </li>
                    </ul>
                  </li>

                  <li>
                    3. Permissions
                    <ul>
                      <li>
                        The App requests necessary permissions, such as location
                        access, to enhance user experience and ensure safety.
                      </li>
                      <li>
                        Users can manage permissions through their device
                        settings.
                      </li>
                    </ul>
                  </li>

                  <li>
                    4. Updates and Maintenance
                    <ul>
                      <li>
                        Regular updates are released to fix bugs, improve
                        performance, and add new features.
                      </li>
                      <li>
                        Users are encouraged to keep the App updated for optimal
                        functionality.
                      </li>
                    </ul>
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">7. Refund and Support Policy</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    1. Refunds
                    <ul>
                      <li>
                        Refunds for ride fares are issued only in cases of
                        overcharging or technical errors.
                      </li>
                      <li>
                        Requests must be submitted via the App's support section
                        within 7 days of the ride.
                      </li>
                    </ul>
                  </li>

                  <li>
                    2. Customer Support
                    <ul>
                      <li>
                        For assistance, users can contact our support team at:
                      </li>
                      <li>Email: info@gravitydrive.in</li>
                      <li>Phone: +91 8007008833</li>
                      <li>In-App Chat Support</li>
                    </ul>
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">8. Dispute Resolution</h2>
            <div className="description_div">
              <p className="grey_class">
                <ul>
                  <li>
                    1. Governing Law
                    <ul>
                      <li>
                        These Terms are governed by the laws of India, and any
                        disputes shall be subject to the exclusive jurisdiction
                        of courts in Pune, Maharashtra.
                      </li>
                    </ul>
                  </li>

                  <li>
                    2. Arbitration
                    <ul>
                      <li>
                        Disputes between users and gravity drive may be resolved
                        through arbitration in accordance with Indian
                        Arbitration laws.
                      </li>
                      <li>
                        Arbitration shall be conducted in Pune, India, and all
                        proceedings shall be in the English language.
                      </li>
                    </ul>
                  </li>
                </ul>
              </p>
            </div>

            <h2 className="head_div">Acknowledgment</h2>
            <div className="description_div">
              <p className="grey_class">
                By using the gravity drive App, you acknowledge that you have
                read, understood, and agreed to these Terms, Conditions, and
                Policies. If you do not agree, please refrain from using the
                App.
              </p>
            </div>

            {/* <div className="btn_class d-flex justify-content-center gap-2">
              <Decline_Btn />
              <Accept_Btn />
            </div> */}
          </div>
        </div>
      </section>
      <Book_Vehicle />
    </>
  );
};

export default Privacy_Policy;
